import {
  useIsGuestOfAssetWorkspace,
  useWorkspaceAsset,
} from '@gripp/shared-logic';
import {
  SlideAction,
  SlideLayout,
  ViewMode
} from '@gripp/shared-ui';
import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { AssetRouteProvider } from '../assetRouteContext';
import { RoutineAllColumn } from './asset-routines-all-column';
import { AssetRoutinesHeader } from './asset-routines-header';
import { AssetCard } from './assetCard';
import { AssetFilters } from './assetFilters';

export const AssetRoutines = () => {
  const { assetId, issueId } = useParams();
  const navigate = useNavigate();
  const { workspaceAsset } = useWorkspaceAsset(assetId ?? '', !assetId);
  const assetWorkspaceId = workspaceAsset?.workspace?.id;
  // View + submit are on the guest allowlist for this route (assetSubRoutes.tsx
  // leaves it unwrapped), but the asset-edit gear (AssetFilters) and the
  // assign/rearrange gear (AssetRoutinesHeader, which navigates to the
  // still-gated routines/edit route) are not -- withhold both here rather than
  // let a guest hit a FORBIDDEN dead end.
  const isGuestOfAssetWorkspace = useIsGuestOfAssetWorkspace(assetWorkspaceId);

  if (!assetId) {
    return null;
  }

  const leftColumn = (
    {
      title: 'assets.menu.title',
      mainComponent: (
        <AssetRouteProvider value={{
          basePath: issueId ? `/activities/${issueId}/asset/${assetId}` : `/assets/${assetId}`,
          listPath: issueId ? '/activities' : '/assets',
          isWorkspaceMode: false,
          issueId,
        }}>
          <AssetCard assetId={assetId} />
        </AssetRouteProvider>
      ),
      showBackButton: true,
      headerComponent: (
        <AssetFilters
          assetId={assetId}
          showEditButton={!isGuestOfAssetWorkspace}
        />
      ),
      backButtonTransition: SlideAction.PREV,
      onBackButtonPress: () => navigate(issueId ? '/activities' : '/assets'),
      disableScroll: true
    }
  );

  const rightColumn = (
    {
      title: 'asset.header.buttons.routines',
      mainComponent: (<RoutineAllColumn assetId={assetId} />),
      // AssetRoutinesHeader self-gates for a guest (assign/rearrange is off
      // the allowlist, view + submit stays on it).
      headerComponent: (
        <AssetRoutinesHeader assetId={assetId} />
      ),
      showBackButton: true,
      backButtonTransition: SlideAction.PREV,
      onBackButtonPress: () => navigate(
        issueId ? `/activities/${issueId}/asset/${assetId}` : `/assets/${assetId}`
      ),
      disableScroll: true
    }
  );

  return (
    <SlideLayout
      leftColumn={leftColumn}
      rightColumn={rightColumn}
      viewMode={ViewMode.DUAL}
    />
  );
};
